/**
 * Logo institucional Campus EMJC — Escuela Municipal de Jóvenes Científicos.
 *
 * Encapsula el `<img>` del PNG ya recortado y con fondo transparente que
 * vive en `apps/web/public/logo-emjc.png`. Hay dos variantes:
 *   - default: silueta y texto en negro institucional, hexágono naranja.
 *     Para fondos claros (header, fondo blanco, etc.).
 *   - inverse: silueta y texto en blanco, hexágono naranja.
 *     Para fondos oscuros (footer sobre brand-ink).
 *
 * No usar este componente para decoraciones puramente gráficas (panal del
 * fondo, hexágono del título de la home, etc.) — para eso seguimos usando
 * `HexLogo`. Este es el logo institucional con texto, no decoración.
 */
interface BrandLogoProps {
  variant?: "default" | "inverse";
  /** Altura en píxeles. El ancho se calcula proporcionalmente al ratio
   *  ~1.61:1 del logo (texto al lado de los hexágonos). */
  height?: number;
  className?: string;
}

export function BrandLogo({
  variant = "default",
  height = 56,
  className = "",
}: BrandLogoProps) {
  const src = variant === "inverse" ? "/logo-emjc-dark.png" : "/logo-emjc.png";
  return (
    <img
      src={src}
      alt="Campus EMJC — Escuela Municipal de Jóvenes Científicos"
      height={height}
      style={{ height, width: "auto" }}
      className={className}
      // Logo siempre debe cargar inmediatamente (LCP), no diferido.
      loading="eager"
      decoding="async"
    />
  );
}
